import { FilteredCreditApplication, Loader } from '@applyonline/shared'
import { EDecision } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import ApprovedPrequalForm from './Components/ApprovedPrequalForm'
import DeclinedPrequalForm from './Components/DeclinedPrequalForm'
import FailedToObtainCreditReportForm from './Components/FailedToObtainCreditReportForm'

interface Props {
  creditApp: FilteredCreditApplication
}

const PrequalResultPage = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  if (creditApp.prequalificationDecision === null) {
    return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />
  }

  const { decision } = creditApp.prequalificationDecision
  if (decision === EDecision.Approved) return <ApprovedPrequalForm creditApp={creditApp} />
  if (decision === EDecision.Refused) return <DeclinedPrequalForm creditApp={creditApp} />
  if (decision === EDecision.Pending) return <FailedToObtainCreditReportForm creditApp={creditApp} />
  return null
}

export default PrequalResultPage
